import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';

import RedirectToSignin, { Props as RedirectToSigninProps } from './RedirectToSignin';

type Props = RedirectToSigninProps & {
  children?: ReactNode;
};

export const RequireAuth = ({ authContext, children }: Props) => {
  const { isConnected, isLoading } = useCurrentUserContext();

  if (isLoading) {
    return null;
  }

  if (!isConnected) {
    return <RedirectToSignin authContext={authContext} />;
  }

  return <>{children ?? <Outlet />}</>;
};

export default RequireAuth;
